export default "__VITE_ASSET__h4HDe4eN__"